import { createContext, useContext } from "react";

export const ThemeAContext = createContext(null);

export function useThemeA(componentName) {
  const context = useContext(ThemeAContext);

  if (!context) {
    throw new Error(
      `[WUI_UNSCOPED_RENDER] ${componentName} must be rendered inside ThemeAProvider.`
    );
  }

  return context;
}
